export default __webpack_public_path__ + "static/media/cardActivationhelpMobileHighlight.6c6e35b1.png";